import React, { Component } from 'react';
import { Select, Menu, Form, Tooltip, Checkbox, TimePicker, Slider, Row, Col, Radio, Dropdown } from 'antd';
import Button from 'components/Button';
import { Img } from 'components/Material';
import Icon from 'components/Icon';
import ColorPicker from 'components/Color';
import Popover from 'components/Popover';
import {
	WorkArea, 
	getDefaultPreviewPath,
	defaultAreaCount,
	showAddAreaVisible,
	getDefaultAreaCls,
	getDefaultFileName,
	canAnchor,
} from 'components/Playlist';

import { showdate, showtime } from './PlaylistUtil';
import config from '@/config';
import $$ from 'cmn-utils';
import './style/mediaArea.less';
import '@/assets/styles/cdms.less';

const notice = config.notice;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const FormItem = Form.Item;
const format = 'HH:mm:ss';

export class FiletypeComb extends Component {
	constructor(props) {
		super();
		this.state = {
			filetypes: [
				{
					key: '1',
					disabled: false,
					placement: 'right',
					title: window.language['playlist.workarea.tipimage'],
				},
				{
					key: '0',
					disabled: false,
					placement: 'right',
					title: window.language['playlist.workarea.tipvideo'],
				},
				{
					key: '2',
					disabled: false,
					placement: 'right',
					title: window.language['playlist.workarea.tipmusic'],
				},
				{
					key: '18',
					disabled: false,
					placement: 'right',
					title: window.language['playlist.workarea.tipdtext'],
				},
				{
					key: '-14',
					disabled: false,
					// placement: 'right',
					// title: '可选中并拖入到视频区',
					subMenus: [
						{
							key: '7',
							disabled: false,
							placement: 'right',
							title: window.language['playlist.workarea.tipweb'],
						},
						{
							key: '14',
							disabled: false,
							placement: 'right',
							title: window.language['playlist.workarea.tiplive'],
						}
					],
				},
				{
					key: '25',
					disabled: false,
					placement: 'right',
					title: window.language['playlist.workarea.tipinteractive'],
				},
				{
					key: '15',
					disabled: false,
					placement: 'right',
					title: window.language['playlist.workarea.tipword'],
				},
				{
					key: '17',
					disabled: false,
					placement: 'right',
					title: window.language['playlist.workarea.tipppt'],
				},
				{
					key: '16',
					disabled: false,
					placement: 'right',
					title: window.language['playlist.workarea.tipexcel'],
				},
				{
					key: '35',
					disabled: false,
					placement: 'right',
					title: window.language['playlist.workarea.tippdf'],
				},
				{
					key: '-21',
					disabled: false,
					// placement: 'right',
					// title: '可选中并拖入到视频区',
					subMenus: [
						{
							key: '21',
							disabled: false,
							placement: 'right',
							title: window.language['playlist.workarea.tipimp'],
						},
						{
							key: '22',
							disabled: false,
							placement: 'right',
							title: window.language['playlist.workarea.tipsingle'],
						},
						{
							key: '23',
							disabled: false,
							placement: 'right',
							title: window.language['playlist.workarea.tipmulti'],
						},
					]
				},
				{
					key: '26',
					disabled: false,
					placement: 'right',
					title: window.language['playlist.workarea.tiptable'],
				},
				// {
				// 	key: '42',
				// 	hidden: true,
				// 	disabled: true,
				// 	placement: 'right',
				// 	title: window.language['playlist.workarea.tipapk'],
				// },
			]
		}
	}
	render() {
		let { filetypes } = this.state;
		let newFiletypes = filetypes.map((filetype) => {
			let {
				key, disabled, placement, title, subMenus,
			} = filetype;
			let content = getDefaultFileName(key);
			title = `[${content}], ${title}`;
			let menuItem = null;
			if (subMenus) {
				menuItem = (
					<Menu.SubMenu key={key} title={content}>
						{
							subMenus.map((subMenu) => {
								content = getDefaultFileName(subMenu.key);
								title = `[${content}], ${subMenu.title}`;
								return (
									<Menu.Item key={subMenu.key} disabled={subMenu.disabled}>
										<Tooltip placement={subMenu.placement} title={title}>
											<div style={{ width: '100%', height: '100%', }}>
												{getDefaultFileName(subMenu.key)}
											</div>
										</Tooltip>
									</Menu.Item>
								)
							})
						}
					</Menu.SubMenu>
				)
			} else {
				menuItem = (
					<Menu.Item key={key} disabled={disabled}>
						<Tooltip placement={placement} title={title}>
							<div style={{ width: '100%', height: '100%', }}>
								{content}
							</div>
						</Tooltip>
					</Menu.Item>
				)
			}
			return menuItem;
		})
		return (
			<Menu {...this.props}>
				{
					newFiletypes
				}
			</Menu>
		)
	}
}
export class PlaylistToolbar extends Component {
	constructor(props) {
		super();
		
	}
	render() {
		let { currentArea, adsorption, onUp, onDown, onTop, onBottom, onDelete,
			onLock, onPreview, onAnchor, onShowFastModel, onAdsorption} = this.props;
		let { lock, anchor_type, areaName } = currentArea;
		return (
			<ul>
				<li title={window.language['playlist.up']} onClick={(event) => {
					onUp && onUp(event, 'workArea', currentArea);
				}}>
					<Icon className="up-circle-o ahover aactive"/>
				</li>
				<li title={window.language['playlist.down']} onClick={(event) => {
					onDown && onDown(event, 'workArea', currentArea);
				}}>
					<Icon className="down-circle-o ahover aactive" />
				</li>
				<li title={window.language['playlist.top']} onClick={(event) => {
					onTop && onTop(event, 'workArea', currentArea);
				}}>
					<Icon className="top ahover aactive" />
				</li>
				<li title={window.language['playlist.bottom']} onClick={(event) => {
					onBottom && onBottom(event, 'workArea', currentArea);
				}}>
					<Icon className="bottom ahover aactive" />
				</li>
				<li className="separator">

				</li>
				<li title={window.language['playlist.preview']} onClick={(event) => {
					onPreview && onPreview(event, 'workArea', currentArea);
				}}>
					<Icon className="preview-o ahover aactive" />
				</li>
				<li title={window.language['playlist.anchor']} onClick={(event) => {
					let { areaType } = currentArea;
					if(canAnchor[areaType]) {
						onAnchor && onAnchor(event, 'workArea', currentArea);
					}else{
						notice.warning(areaName + window.language['playlist.anchorAreacheck'])
					}
				}}>
					{
						anchor_type === 1 ? <Icon className="anchor ahover aactive" />: 
						<Icon className="anchor-o ahover aactive" />
					}
				</li>
				{
					lock ? (
						<li title={window.language['playlist.unlock']} onClick={(event) => {
							onLock && onLock(event, 'workArea', currentArea);
						}}>
							<Icon className="unlock-o ahover aactive" />
						</li>
					) : (
						<li title={window.language['playlist.lock']} onClick={(event) => {
							onLock && onLock(event, 'workArea', currentArea);
						}}>
							<Icon className="lock-o ahover aactive" />
						</li>
					)
				}
				{
					adsorption ? (
						<li title={window.language['playlist.adsorption']} onClick={(event) => {
							onAdsorption && onAdsorption(event, 'workArea', false);
						}}>
							<Icon className="adsorption ahover aactive" />
						</li>
					): (
						<li title={window.language['playlist.cancelAdsorption']} onClick={(event) => {
							onAdsorption && onAdsorption(event, 'workArea', true);
						}}>
							<Icon className="adsorption-o ahover aactive" />
						</li>
					)
				}
				
				<li className="separator">

				</li>
				{/* <li title={window.language['playlist.save']} onClick={(event) => {
					onSave && onSave(event, 'workArea', currentArea);
				}}>
					<Icon className="save-o ahover aactive" />
				</li> */}
				<li title={window.language['playlist.delete']} onClick={(event) => {
					onDelete && onDelete(event, 'workArea', currentArea);
				}}>
					<Icon className="delete-o ahover aactive" />
				</li>
				<li title={window.language['playlist.hotkey']} onClick={(event) => {
					onShowFastModel && onShowFastModel(true);
				}}>
					<Icon className="question-o ahover aactive" style={{color: 'red'}}/>
				</li>
			</ul>
		)
	}
}
export class AreaButtonComb extends Component {
	constructor(props) {
		super();
		this.areatypes = [
			{
				key: 0,
				title: window.language['playlist.workarea.title0'],
				tooltip: window.language['playlist.workarea.btn0'],
			},
			{
				key: 1,
				title: window.language['playlist.workarea.title1'],
				tooltip: window.language['playlist.workarea.btn1'],
			},
			{
				key: 2,
				title: window.language['playlist.workarea.title2'],
				tooltip: window.language['playlist.workarea.btn2'],
			},
			{
				key: 3,
				title: window.language['playlist.workarea.title3'],
				tooltip: window.language['playlist.workarea.btn3'],
			},
			{
				key: 4,
				title: window.language['playlist.workarea.title4'],
				tooltip: window.language['playlist.workarea.btn4'],
			},
			{
				key: 5,
				title: window.language['playlist.workarea.title5'],
				tooltip: window.language['playlist.workarea.btn5'],
			},
			{
				key: 7,
				title: window.language['playlist.workarea.title7'],
				tooltip: window.language['playlist.workarea.btn7'],
			},
		]
	}
	render() {
		let { areaArray, currentPageId, addArea } = this.props;
		let { areatypes } = this;
		let newAreatypes = areatypes.map((areatype) => {
			let {
				key, title, tooltip,
			} = areatype;
			let disabled = showAddAreaVisible(areaArray, currentPageId, key) ? "disabled" : "";
			return <Popover key={key} placement="rightTop" title={title} content={tooltip.replace('{1}', defaultAreaCount[key])}>
				<li
					// tooltip={tooltip.replace('{1}', defaultAreaCount[key])}
					// title={tooltip.replace('{1}', defaultAreaCount[key])}
					className={disabled}
					onClick={() => {
						if("" === disabled){
							addArea(key)();
						}else{
							notice.warning(tooltip.replace('{1}', defaultAreaCount[key]));
						}
					}} >
						<div></div>
						<Icon className={getDefaultAreaCls(key)}></Icon>
				</li>
			</Popover>;
		})
		return (
			<ul>
				{
					newAreatypes
				}
			</ul>
		)
	}
}
export class MoreAreaButtonComb extends Component {
	constructor(props) {
		super();
		this.state = {
			areatypes: [
				{
					key: 7,
					tooltip: window.language['playlist.workarea.btnweb'],
					content: window.language['playlist.workarea.webpage'],
				},
				{
					key: 28,
					tooltip: window.language['playlist.workarea.btnmask'],
					content: window.language['playlist.workarea.maskpage'],
				},
				{
					key: 26,
					tooltip: window.language['playlist.workarea.btntable'],
					content: window.language['playlist.workarea.tablepage'],
				},
				{
					key: 19,
					tooltip: window.language['playlist.workarea.btnfloor'],
					content: window.language['playlist.workarea.floorpage'],
				},
				{
					key: 78,
					tooltip: window.language['playlist.workarea.btnpm'],
					content: window.language['playlist.workarea.pmpage'],
				},
				{
					key: 20,
					tooltip: window.language['playlist.workarea.btntouch'],
					content: window.language['playlist.workarea.touchpage'],
				},
			]
		}
	}
	render() {
		let { areaArray, currentArea, addArea } = this.props;
		let { areatypes } = this.state;
		let newAreatypes = areatypes.map((areatype) => {
			let {
				key, tooltip, content,
			} = areatype;
			return (<Menu.Item key={key} disabled={showAddAreaVisible(areaArray, currentArea)[key]} onClick={addArea(key)} >
				<Tooltip title={tooltip.replace('{1}', defaultAreaCount[key])}>
					<div style={{ width: '100%', height: '100%', }}>
						<span className={getDefaultAreaCls(key)} /> {content}
					</div>
				</Tooltip>
			</Menu.Item>)
		})
		return (
			<Menu>
				{
					newAreatypes
				}
			</Menu>
		)
	}
}

export class PlaylistScene extends Component {
	constructor(props) {
		super();
	}
	render() {
		let { areaMap, onDrag, onDelete, onUp, onDown, onCopy, currentPageId, 
			onDragStart,
			onDragEnd,
			onDragEnter,
			onDragOver,
			onDrop,
			...otherProps } = this.props;
		let areaArrays = [];
		for (let [key, value] of areaMap.entries()) {
			areaArrays.push(value);
		}
		let newData = areaArrays.map((areaArray, index) => {
			let flag = areaArray.some((element, index, array) => {
				return element.areaId === currentPageId;
			})
			let area = null;
			for(let i = 0; i < areaArray.length; i++){
				area = areaArray[i];
				if(area.areaType === 9){
					break;
				}
			}
			let liProps = {
				draggable: true,
				onMouseDown: (event) => {
					onDrag && onDrag(area);
				},
				onDragStart: (event) => {
					onDragStart && onDragStart(event, 'scene', area);
				},
				onDragEnd: (event) => {
					onDragEnd && onDragEnd(event, 'scene', area);
				},
				onDragEnter: (event) => {
					onDragEnter && onDragEnter(event, 'scene', area);
				},
				onDragOver: (event) => {
					onDragOver && onDragOver(event, 'scene', area);
				},
				onDrop: (event) => {
					onDrop && onDrop(event, 'scene', area);
				},
			}
			return(
				<li key={index} className={flag ? 'selected' : ''}
					{...liProps}
					>
					<div className="scene-index">
						{index > 98 ? '...' : index + 1}
					</div>
					<Icon className={"up-circle-o ahover aactive"} title={window.language['playlist.up']} onClick={(event) => {
						onDrag && onDrag(area);
						onUp && onUp(event, 'scene', area);
					}}/>
					<Icon className={"down-circle-o ahover aactive"} title={window.language['playlist.down']} onClick={(event) => {
						onDrag && onDrag(area);
						onDown && onDown(event, 'scene', area);
					}}/>
					<Icon className={"copy-o ahover aactive"} title={window.language['playlist.hotkey.copy']} onClick={(event) => {
						onDrag && onDrag(area);
						onCopy && onCopy(event, 'scene', area);
					}}/>
					<Icon className={"delete-o ahover aactive"} title={window.language['playlist.hotkey.delete']} onClick={(event) => {
						onDrag && onDrag(area);
						onDelete && onDelete(event, 'workArea', area);
					}}/>
					<WorkArea {...otherProps} areaArray={areaArray} onDrag={onDrag}/>
				</li>
			)
		})
		return (
			<ul>
				{
					newData
				}
			</ul>
		)
	}
}

export class SenseListComb extends Component {
	render() {
		let { sensePageData: { list: senseList } } = this.props;
		return (
			<Select {...this.props}>
				{
					senseList.map((ele) => {
						let sense = ele.width + 'x' + ele.height;
						return (
							<Option key={sense} value={sense}>{sense}</Option>
						)
					})
				}
			</Select>
		)
	}
}

export class DirectionComb extends Component {
	render() {
		let directions = [
			//['0', window.language['playlist.textarea.rollmode1']], 
			{ label: window.language['playlist.textarea.rollmode2'], value: '1' },
			{ label: window.language['playlist.textarea.rollmode3'], value: '2' },
			{ label: window.language['playlist.textarea.rollmode4'], value: '3' },
			{ label: window.language['playlist.textarea.rollmode5'], value: '4' },
		]
		const { width, formItemProps, value, onSelect } = this.props;
		let defaultFormItemProps = {
			labelCol: { span: 12 },
			wrapperCol: { span: 12 },
			label: window.language['playlist.title.rollmode'],
			...formItemProps
		}
		return (
			<FormItem {...defaultFormItemProps}>
				<RadioGroup 
					options={directions} 
					value={value}
					onChange={(e) => { 
						onSelect && onSelect(e.target.value); 
					}}
				/>
			</FormItem>
		)
	}
}

export class SizeComb extends Component {
	// render() {
	// 	let { minValue = 1, maxValue = 100, step = 1, values } = this.props;
	// 	let sizeOptions = [];
	// 	//var sizes = [];
	// 	if (values) {
	// 		for (let value of values) {
	// 			//sizes.push([value, value + 'px']);
	// 			sizeOptions.push(<Option key={value} value={value}>{value + 'px'}</Option>);
	// 		}
	// 	} else {
	// 		while (minValue <= maxValue) {
	// 			//sizes.push([minValue, minValue + 'px']);
	// 			sizeOptions.push(<Option key={minValue} value={minValue}>{minValue + 'px'}</Option>);
	// 			minValue += step;
	// 		}
	// 		//sizes.push([maxValue, maxValue + 'px']);
	// 	}

	// 	const { width, formItemProps, ...otherField } = this.props;
	// 	let defaultFormItemProps = {
	// 		labelCol: { span: 12 },
	// 		wrapperCol: { span: 12 },
	// 		label: window.language['playlist.font.size'],
	// 		...formItemProps
	// 	}
	// 	return (
	// 		<FormItem {...defaultFormItemProps}>
	// 			<Select style={{ width }} {...otherField}>
	// 				{sizeOptions}
	// 				{/* {
	// 					sizes.map((ele) => {
	// 						return (
	// 							<Option key={ele[0]} value={ele[0]}>{ele[1]}</Option>
	// 						)
	// 					})
	// 				} */}
	// 			</Select>
	// 		</FormItem>
	// 	)
	// }

	render() {
		let { minValue = 12, maxValue = 100, step = 1, values, value, onSelect } = this.props;
		function formatter(value) {
			return `${value}px`;
		}
		const { width, formItemProps, ...otherField } = this.props;
		let defaultFormItemProps = {
			labelCol: { span: 12 },
			wrapperCol: { span: 12 },
			label: window.language['playlist.font.size'],
			...formItemProps
		}
		return (
			<React.Fragment>
				<FormItem {...defaultFormItemProps} style={{marginBottom: 0}}>
				</FormItem>
				<FormItem style={{marginBottom: formItemProps.style.marginBottom}}>
					<Row>
						<Col span={1}>
						</Col>
						<Col span={19}>
							<Slider style={{ width: '90%' }}
								tipFormatter={formatter}
								min={minValue}
								max={maxValue}
								value={value}
								onChange={(value) => { 
									onSelect && onSelect(value); 
								}}
							/>
						</Col>
						<Col span={4} className={"opacityText"}>
							{formatter(value)}
						</Col>
					</Row>
				</FormItem>
			</React.Fragment>
		)
	}
}

export class FamilyComb extends Component {
	render() {
		let { values, } = this.props;
		let familys = [
			//['Arial', 'Arial'], 
			['1', window.language['common.blackBody']],
		]
		if (values) {
			familys = values.map((value) => {
				return [value.id, value.font_name];
			})
		}
		const { width, formItemProps, ...otherField } = this.props;
		let defaultFormItemProps = {
			labelCol: { span: 12 },
			wrapperCol: { span: 12 },
			label: window.language['playlist.font.face'],
			...formItemProps
		}

		return (
			<FormItem {...defaultFormItemProps}>
				<Select style={{ width }} {...otherField}>
					{
						familys.map((ele) => {
							return (
								<Option key={ele[0]} value={ele[0]}>{ele[1]}</Option>
							)
						})
					}
				</Select>
			</FormItem>
		)
	}
}

export class SpeedComb extends Component {
	render() {
		const marks = {
			1: window.language['playlist.textarea.rollspeed2'],
			2: window.language['playlist.textarea.rollspeed3'],
			3: window.language['playlist.textarea.rollspeed4'],
			4: window.language['playlist.textarea.rollspeed5'],
		};
		function formatter(value) {
			return marks[value];
		}
		const { width, formItemProps, value, onSelect } = this.props;
		let defaultFormItemProps = {
			...formItemProps,
			labelCol: { span: 8 },
			wrapperCol: { span: 16 },
			label: window.language['playlist.title.rollspeed'],
		}
		let valuev = parseInt(value, 10);
		return (
			<React.Fragment>
				<FormItem {...defaultFormItemProps} style={{marginBottom: 0}}>
				</FormItem>
				<FormItem style={{marginBottom: formItemProps.style.marginBottom}}>
					<Row>
						<Col span={1}>
						</Col>
						<Col span={19}>
							<Slider style={{ width: '90%' }}
								tipFormatter={formatter}
								dots={true} 
								marks={marks} 
								min={1} 
								max={4} 
								step={1} 
								value={valuev}
								onChange={(value) => { 
									onSelect && onSelect(value, 'rollspeed');
								}} 
								included={false} 
							/>
						</Col>
						<Col span={4} className={"speedText"}>
							{marks[value]}
						</Col>
					</Row>
				</FormItem>
			</React.Fragment>
		)
	}
}

export class OpacityComb extends Component {
	render() {
		function formatter(value) {
			return `${value}%`;
		}

		const { width, formItemProps, value, onSelect } = this.props;
		let defaultFormItemProps = {
			...formItemProps,
			labelCol: { span: 9 },
			wrapperCol: { span: 15 },
			label: window.language['playlist.opacity'],
		}
		let valuev = parseInt((value + "").replace("%", ""));
		return (
			<React.Fragment>
				<FormItem {...defaultFormItemProps} style={{marginBottom: 0}}>
				</FormItem>
				<FormItem style={{marginBottom: formItemProps.style.marginBottom}}>
					<Row>
						<Col span={1}>
						</Col>
						<Col span={19}>
							<Slider style={{ width: '90%' }}
								tipFormatter={formatter}
								min={0}
								max={100}
								value={valuev}
								onChange={(value) => { 
									onSelect && onSelect(value + '%'); 
								}}
							/>
						</Col>
						<Col span={4} className={"opacityText"}>
							{value}
						</Col>
					</Row>
				</FormItem>
			</React.Fragment>
		)
	}
}

export class TextStyleComb extends Component {
	render() {
		const { width, bold, italic, underline, updateBold, updateItalic, updateUnderline, size, formItemProps, ...otherField } = this.props;

		let defaultFormItemProps = {
			labelCol: { span: 12 },
			wrapperCol: { span: 12 },
			label: window.language['playlist.text.fontstyle'],
			...formItemProps
		}
		return (
			<FormItem {...defaultFormItemProps}>
				<Button.Group style={{ width }} {...otherField}>
					<Button customicon="iconfont icon-bold" type={bold === 'bold' ? "primary" : ""} tooltip="粗体"
						size={size}
						onClick={() => {
							updateBold && updateBold(bold === 'bold' ? '' : 'bold')
						}}
					></Button>
					<Button customicon="iconfont icon-italic" type={italic === 'italic' ? "primary" : ""} tooltip="斜体"
						size={size}
						onClick={() => {
							updateItalic && updateItalic(italic === 'italic' ? '' : 'italic')
						}}
					></Button>
					<Button customicon="iconfont icon-underline" type={underline === 'underline' ? "primary" : ""} tooltip="下划线"
						size={size}
						onClick={() => {
							updateUnderline && updateUnderline(underline === 'underline' ? '' : 'underline')
						}}
					></Button>
				</Button.Group>
			</FormItem>
		)
	}
}

export class AlignComb extends Component {
	render() {
		const { width, align, updateAlign, size, formItemProps, ...otherField } = this.props;

		let defaultFormItemProps = {
			labelCol: { span: 12 },
			wrapperCol: { span: 12 },
			label: window.language['playlist.text.fontposition'],
			...formItemProps
		}
		return (
			<FormItem {...defaultFormItemProps}>
				<Button.Group style={{ width }} {...otherField}>
					<Button customicon="iconfont icon-left" type={align === 'left' ? "primary" : ""} tooltip="靠左"
						size={size}
						onClick={() => {
							updateAlign && updateAlign('left')
						}}
					></Button>
					<Button customicon="iconfont icon-center" type={align === 'center' ? "primary" : ""} tooltip="居中"
						size={size}
						onClick={() => {
							updateAlign && updateAlign('center')
						}}
					></Button>
					<Button customicon="iconfont icon-right" type={align === 'right' ? "primary" : ""} tooltip="靠右"
						size={size}
						onClick={() => {
							updateAlign && updateAlign('right')
						}}
					></Button>
				</Button.Group>
			</FormItem>
		)
	}
}

export class StyleComb extends Component {
	render() {
		let common = {
			'1': window.language['playlist.template.style1'],
			'2': window.language['playlist.template.style2'],
			'3': window.language['playlist.template.style3'],
			'4': window.language['playlist.template.style4'],
			'5': window.language['playlist.template.style5'],
		}
		const { width, values, formItemProps, ...otherField } = this.props;

		let styles = values.map((ele) => {
			return [ele, common[ele]];
		})
		let defaultFormItemProps = {
			labelCol: { span: 12 },
			wrapperCol: { span: 12 },
			label: window.language['playlist.text.fontstyle'],
			...formItemProps
		}
		return (
			<FormItem {...defaultFormItemProps}>
				<Select style={{ width }} {...otherField}>
					{
						styles.map((ele) => {
							return (
								<Option key={ele[0]} value={ele[0]}>{ele[1]}</Option>
							)
						})
					}
				</Select>
			</FormItem>
		)
	}
}


export class DateStyleComb extends Component {
	render() {
		// let common = {
		// 	'1': window.language['playlist.template.datestyle1'],
		// 	'2': window.language['playlist.template.datestyle2'],
		// 	'3': window.language['playlist.template.datestyle3'],
		// 	'4': window.language['playlist.template.datestyle4'],
		// 	'5': window.language['playlist.template.datestyle5'],
		// }
		let common = {
			'1': showdate('1'),
			'2': showdate('2'),
			'3': showdate('3'),
			'4': showdate('4'),
			'5': showdate('5'),
			'6': showdate('6'),
			'7': showdate('7'),
			'8': showdate('8'),
			'9': showdate('9'),
			'10': showdate('10'),
		}
		const { width, values, formItemProps, ...otherField } = this.props;

		let styles = values.map((ele) => {
			return [ele, common[ele]];
		})
		let defaultFormItemProps = {
			labelCol: { span: 12 },
			wrapperCol: { span: 12 },
			label: window.language['playlist.text.fontstyle'],
			...formItemProps
		}
		return (
			<FormItem {...defaultFormItemProps}>
				<Select style={{ width }} {...otherField}>
					{
						styles.map((ele) => {
							return (
								<Option key={ele[0]} value={ele[0]}>{ele[1]}</Option>
							)
						})
					}
				</Select>
			</FormItem>
		)
	}
}


export class TimeStyleComb extends Component {
	render() {
		// let common = {
		// 	'1': window.language['playlist.template.style1'],
		// 	'2': window.language['playlist.template.style2'],
		// 	'3': window.language['playlist.template.style3'],
		// 	'4': window.language['playlist.template.style4'],
		// 	'5': window.language['playlist.template.style5'],
		// }
		let common = {
			'1': showtime('1'),
			'2': showtime('2'),
			'3': showtime('3'),
			'4': showtime('4'),
			'5': showtime('5'),
		}
		const { width, values, formItemProps, ...otherField } = this.props;

		let styles = values.map((ele) => {
			return [ele, common[ele]];
		})
		let defaultFormItemProps = {
			labelCol: { span: 12 },
			wrapperCol: { span: 12 },
			label: window.language['playlist.text.fontstyle'],
			...formItemProps
		}
		return (
			<FormItem {...defaultFormItemProps}>
				<Select style={{ width }} {...otherField}>
					{
						styles.map((ele) => {
							return (
								<Option key={ele[0]} value={ele[0]}>{ele[1]}</Option>
							)
						})
					}
				</Select>
			</FormItem>
		)
	}
}

export class WeatherStyleComb extends Component {
	render() {
		let styles = [
			['8', window.language['playlist.template.style1']],
			['9', window.language['playlist.template.style2']],
			['1', window.language['playlist.template.style3']],
			['3', window.language['playlist.template.style4']],
			['5', window.language['playlist.template.style5']],
			['4', window.language['playlist.template.style6']],
			// ['6', window.language['playlist.template.style5']], 
			// ['2', window.language['playlist.template.style6']], 
		]
		const { width, values, formItemProps, ...otherField } = this.props;

		let defaultFormItemProps = {
			labelCol: { span: 12 },
			wrapperCol: { span: 12 },
			label: window.language['playlist.text.fontstyle'],
			...formItemProps
		}
		return (
			<FormItem {...defaultFormItemProps}>
				<Select style={{ width }} {...otherField}>
					{
						styles.map((ele) => {
							return (
								<Option key={ele[0]} value={ele[0]}>{ele[1]}</Option>
							)
						})
					}
				</Select>
			</FormItem>
		)
	}
}

export class ColorPickerComb extends Component {
	render() {
		const { width, color, formItemProps, onChange, onBlur, ...otherProps } = this.props;

		let defaultFormItemProps = {
			labelCol: { span: 12 },
			wrapperCol: { span: 12 },
			label: window.language['playlist.font.color'],
			...formItemProps,
			...otherProps
		}
		
		return (
			<FormItem {...defaultFormItemProps} style={{ marginBottom: formItemProps && formItemProps.style.marginBottom }}>
				<div style={{
                  position: 'relative',
                  width: width,
                  height: width,
                }}>
                  <div style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: width,
                    height: width,
                    backgroundColor: '#000000',
                    borderRadius: '50%',
                    opacity: 0.11,
                  }}>
                  </div>
				  <ColorPicker
				  	{...otherProps}
                    style={{
                      position: 'absolute',
                      left: 4,
                      top: 4,
                      width: width - 8,
					  height: width - 8,
					  borderRadius: '50%',
                    }}
                    color={color} 
                    onChange={ (color) => {
						onChange &&　onChange(color);
                    }} 
                    onBlur={ (color) => {
						onBlur && onBlur(color);
                    }} 
                  />
                </div>
			</FormItem>
		)
	}
}

export class ColorPickerCircle extends Component {
	constructor(){
		super();
		let colors = $$.getStore("colors") || [
			'#ffffff',
			'#3d495f',
			'#ff8989',
			'#ffe277',
			'#59a9ff',
			'#85dd5e',
			'#af98d8',
			'#e3e3e3',
		];
		this.state = {
			colors
		};
	}

	changeColors = (color) => {
		let { colors } = this.state;
		let newcolor = [];
		newcolor[0] = color;
		for(let i = 0; i < colors.length; i++) {
			let ele = colors[i];
			if(color !== ele){
				newcolor.push(ele);
			}
			if(newcolor.length === 8) {
				break;
			}
		}
		this.setState({
			colors: newcolor
		})
		$$.setStore("colors", newcolor);
	}
	render() {
		let { 
			type, 
			formItemProps, 
			label,
			color,
			width,
			onChange,
			onClick,
		} = this.props;
		let { colors } = this.state;
		
		let colorCircle = colors.map((color, index) => {
			return (
				<Col span={6} key={index}>
					<FormItem>
						<div style={{
							position: 'relative',
							width: width,
							height: width,
						}}>
							<div style={{
								position: 'absolute',
								left: 0,
								top: 0,
								width: width,
								height: width,
								backgroundColor: '#000000',
								borderRadius: '50%',
								opacity: 0.11,
							}} />
							<div 
								style={{
									position: 'absolute',
									cursor: 'pointer',
									left: 4,
									top: 4,
									width: width - 8,
									height: width - 8,
									backgroundColor: color,
									borderRadius: '50%',
								}}
								onClick={ () => {
									this.changeColors(color);
									onClick && onClick(color);
								}} 
							/>
						</div>
					</FormItem>
				</Col>
			)
		})

		return (
			<React.Fragment>
				<Row>
					<Col span={24}>
						<ColorPickerComb 
							type={type}
							formItemProps={formItemProps}
							label={label}
							color={color} 
							width={ width }
							onChange={ (color) => {
								onChange && onChange(color);
							} } 
							onBlur={ (color) => {
								this.changeColors(color);
							} }
						/>
					</Col>
				</Row>
				{
					colorCircle
				}
			</React.Fragment>
		);
	}
}

export class TransitmodeComb extends Component {
	constructor(){
		super();
	}

	onRightShowTransitMode = (transitmode, filetype) => {
		const row1 = [
			{key: 6 }, {key: 7 }, {key: 5 }, {key: 4 },
			{key: 13 }, {key: 14 }, {key: 15 }, {key: 16 },
			{key: 8 }, {key: 9 }, {key: 1 }, {key: 0 },
			{key: 17 }, {key: 19 }, {key: 18 }, {key: 20 },
			{key: 22 }, {key: 21 }, {key: 10 }, {key: 32 },
			{key: 25 }, {key: 29 }, {key: 24 }, {key: 23 },
		];
		
		let { onOperateMediaarea, onEdit, media } = this.props;
		let tcNode = row1.map((row, index) => {
			let { key } = row;
			let selected = transitmode === key ? 'selected' : '';
			let transitmodeProps = {
				value: key, 
				content: '', 
				selected, 
				filetype, 
			}
			return (
				<Col  key={index} className="small-transitmode-select-col" 
					onClick={(e) => { 
						onOperateMediaarea ? onOperateMediaarea(null, 'mediaArea', media, () => {
							onEdit && onEdit('transitmode', 'mediaArea', key);
						}) : onEdit && onEdit('transitmode', 'mediaArea', key);
					}}
				>
					<div className="small-transitmode">
						<TransitmodeComb {...transitmodeProps}/>
					</div>
				</Col>
			)
		});
		return (
			<Row style={{ width:'156px' }} selectable="false" focusable="true">
				{tcNode}
			</Row>
		)
	}

	render() {
		let { size, value: key, content, selected, filetype, rightMode, changeTransitMode, onEdit } = this.props;
		let className = "transitmode" + key + " ahover aactive " + selected;
		if (size === 'small') {
			className = "transitmode" + key + " aactive ";
		}
		let bodyNode = (
			<div className={className} onClick={(e) => { 
				if (!rightMode) {
					changeTransitMode && changeTransitMode(key);
					onEdit && onEdit('transitmode', 'mediaArea', key, filetype);
				}
			}}>
				<div className={"div1"}>
					<Img className={"circle"} src="assets/images/transform/实体圆.png" />
					<Img className={"arrow1"} src="assets/images/transform/箭头.png" />
					<Img className={"arrow2"} src="assets/images/transform/箭头.png" />
					<Img className={"arrow3"} src="assets/images/transform/箭头.png" />
					<Img className={"arrow4"} src="assets/images/transform/箭头.png" />
					<Img className={"stars1"} src="assets/images/transform/实体星.png" />
					<Img className={"stars2"} src="assets/images/transform/实体星.png" />
					<Img className={"staro1"} src="assets/images/transform/百叶星.png" />
					<Img className={"msker1"} src="assets/images/transform/马赛克.png" />
					<Img className={"zjcuo1"} src="assets/images/transform/左交错.png" />
					<Img className={"yjcuo1"} src="assets/images/transform/右交错.png" />
					<div className={"juchi1div"}>
						<Img className={"juchi1"} src="assets/images/transform/锯齿.png" />
					</div>
				</div>
				{
					content ? <div className={"div2"}>{content}</div> : null
				}
				{
				  	rightMode ? <div className={"divIcon"}><Icon className="d-arrow" /></div> : null
				}
			</div>
		);
		if (rightMode) {
			let rightNode = this.onRightShowTransitMode(key, filetype);
			return (
				<Dropdown overlay={rightNode} trigger={['click']}>
					{bodyNode}
				</Dropdown>
			);
		}
		return bodyNode;
	}
}

{/* <div className={"transitmode" + key + " ahover aactive " + selected} onClick={() => { 
				changeTransitMode(key);
				onEdit('transitmode', 'mediaArea', key, filetype) 
			}} >
				<div className={"div1"}>
					<Img className={"circle"} src="assets/images/transform/实体圆.png" />
					<Img className={"arrow1"} src="assets/images/transform/箭头.png" />
					<Img className={"arrow2"} src="assets/images/transform/箭头.png" />
					<Img className={"arrow3"} src="assets/images/transform/箭头.png" />
					<Img className={"arrow4"} src="assets/images/transform/箭头.png" />
					<Img className={"stars1"} src="assets/images/transform/实体星.png" />
					<Img className={"stars2"} src="assets/images/transform/实体星.png" />
					<Img className={"staro1"} src="assets/images/transform/百叶星.png" />
					<div className={"juchi1div"}>
						<Img className={"juchi1"} src="assets/images/transform/锯齿.png" />
					</div>
				</div>
				<div className={"div2"}>{key}{content}</div>
			</div> */}


// WEBPACK FOOTER //
// ./src/components/Playlist/PlaylistComb.js